var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wg-wpr",attrs:{"id":"jrm-embeded-content"}},[_vm._t("header",[_c('the-header',[_vm._t("header-title")],2)]),_vm._t("default"),_vm._t("footer",[_c('TheFooter')])],2)}
var staticRenderFns = []

export { render, staticRenderFns }